import React from 'react';
import { Row, Col } from 'reactstrap';
import Dropzone from 'react-dropzone';
import Cropper from 'react-cropper';
import DatePicker from "react-datepicker";
import UserVideoListing from "../../components/video-ui/UserVideoListing";
import SocialIconsHeader from '../../components/social/SocialIconsHeader';
import { SocialIcon } from 'react-social-icons';
import moment from 'moment';
import '../../../node_modules/cropperjs/dist/cropper.css';
import '../../../node_modules/react-datepicker/dist/react-datepicker.css';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { MdInfoOutline } from "react-icons/md";
import ReactTooltip from 'react-tooltip';
import "../../styles/profile.css";
import AriaModal from 'react-aria-modal';
import BlockUi from 'react-block-ui';
import ApiClient from "../../api/ApiClient";
import { verifyTextContent } from "../../utils/verifyText";
import DisappearNotification from "./../../modals/disappearNotification";
import { connect } from 'react-redux';
import { updateScore, populateStore, requestFailedModal } from '../../actions';
const queryString = require('query-string');



class UserProfileContainer extends React.Component {
    constructor(props) {
        super(props);
        this.apiClient = new ApiClient();
        const parsed = queryString.parse(props.location.search);
        const userId = parsed.userId !== undefined ? parsed.userId : this.props.loggedInUser;
        const emailId = parsed.email !== undefined ? parsed.email : this.props.email;

        this.state = {
            userId: parsed.userId !== undefined ? parsed.userId : this.props.loggedInUser,
            loggedInUser: this.props.loggedInUser,
            loggedInUserEmail: this.props.email,
            thirdPartyUserid: parsed.uniqueId !== undefined ? parsed.uniqueId : this.props.thirdPartyUserid,
            loggedInUserUniqueId: this.props.thirdPartyUserid,
            userLevel: this.props.userLevel,
            isSocialMediaEnabled: parsed.isSocialEnabled,
            signedInGroupId: this.props.signedInGroupId,
            isYourProfile: false,
            targetUserId: undefined,
            userName: '',
            email: emailId,
            allowProfileRender: false,
            TotalRecordedVideos: 0,
            TotalVerifiedVideos: 0,
            TotalUserVideosCount: 0,
            TotalModelVideosCount: 0,
            RecordVideoPercentage: 0,
            VerifyVideoPercentage: 0,
            isProfileLoading: false,
            isProfileLoaded: false,
            showConfirmDeleteDialog: false,
            gender: '',
            dob: '',
            aslLevel: '',
            identity: '',
            startedAge: '',
            homeState: '',
            aboutMe: '',
            openUploadModal: false,
            uploadedFile: null,
            uploadedImgSrc: '',
            originalImgSrc: '',
            cropResult: '',
            profileImg: '',
            profilepicbuttonsEnable: true,
            readonly: true,
            enableEdit: false,
            isEditAvailable: this.props.loggedInUser === userId,
            userVideos: [],
            tabState: "DictionaryVideos",
            userAge: undefined,
            editMode: false
        }
        const self = this;
        this.cropImage = this.cropImage.bind(this);
        this.deleteUserAccount = this.deleteUserAccount.bind(this);
        this.restoreOriginal = this.restoreOriginal.bind(this);
        this.enableEdit = this.enableEdit.bind(this);
        //this.calculateAge = this.calculateAge.bind(this);
    }

    showConfirmDeleteDialog = () => {
        this.setState({ showConfirmDeleteDialog: !this.state.showConfirmDeleteDialog });
    }

    deleteUserAccount = async () => {
        var vresponse = await this.apiClient.postJSON(this, "/deleteUserAccount", this.props);
        if (vresponse && vresponse.status) {
            if (vresponse.status === 200) {
                await this.setState({ show: false });
                localStorage.removeItem("jwtToken");
                alert("Your account is about to be deleted. Your account information and videos are no longer visible. If this was a mistake, we'll keep your account for a time, and you can login again to restore its contents.")
                window.location.href = process.env.PUBLIC_URL + "/tpLogin";
            }
            else {
                alert("Unable to delete");
            }
            return vresponse;
        }
        else if (vresponse && vresponse.httpServerError) {
            // throw "Something Went Wrong With User Action";
        }
    }

    whichUser = async () => {
        const urlString = window.location.href;
        var url = new URL(urlString);
        var uid = url.searchParams.get("userId");
        const self = this;
        // if (self.state.targetProfileId) {
        //     
        // }
        // if (((this.state.targetProfileId !== uid)  && (!this.state.isProfileLoading && !this.state.isProfileLoaded))) {
        //     this.loadProfile(this.state.targetProfileId);
        // }

        // Another users account
        if (uid) {
            await this.setState({ isYourProfile: false, targetProfileId: uid });
        }
        else {
            await this.setState({ isYourProfile: true, targetProfileId: null });
        }

    }

    componentDidMount() {
        var self = this;
        let jwt = localStorage.getItem("jwtToken");
        if (!jwt) {
            window.location = process.env.PUBLIC_URL + "/tpLogin";
        }
        else {
            this.setState({ allowProfileRender: true })
        }
        this.whichUser()
        const parsed = queryString.parse(this.props.location.search);
        const thirdPartyUserid = parsed.uniqueId !== undefined ? parsed.uniqueId : this.props.thirdPartyUserid;
        this.loadProfile(thirdPartyUserid);
    }
    componentWillReceiveProps(props) {
        const self = this;
        const parsed = queryString.parse(props.location.search);
        const userId = parsed.userId !== undefined ? parsed.userId : this.props.loggedInUser;
        const thirdPartyUserid = parsed.uniqueId !== undefined ? parsed.uniqueId : props.thirdPartyUserid;
        this.setState({
            loggedInUser: props.loggedInUser,
            loggedInUserEmail: props.email,
            userLevel: props.userLevel,
            loggedInUserUniqueId: props.thirdPartyUserid,
            thirdPartyUserid: parsed.uniqueId !== undefined ? parsed.uniqueId : props.thirdPartyUserid,
            userId: parsed.userId !== undefined ? parsed.userId : props.loggedInUser,
            isEditAvailable: props.loggedInUser === userId,
            signedInGroupId: props.signedInGroupId
        });
        if ((thirdPartyUserid !== props.loggedInUser) && (!this.state.isProfileLoading)) {

            this.loadProfile(thirdPartyUserid);
        }
    }

    loadProfile = async (thirdPartyUserid) => {

        await this.setState({
            isProfileLoading: true
        });
        let self = this;
        if (self.state.isYourProfile) {

            this.loadUserScores();
        }
        await this.setState({ isProfileLoading: true });

        this.apiClient.getJSON(this, "/loadProfile?thirdPartyUserId=" + thirdPartyUserid)
            .then((res) => {
                if (res && res.status) {
                    if (res.data.profile !== null) {
                        if (res.data.profile.birthday !== null) {
                            this.calculateAge(new Date(res.data.profile.birthday));
                        }
                        this.setState({
                            isProfileLoaded: true,
                            isProfileLoading: false,
                            xpPoints: res.data.xpPoints,
                            gender: res.data.profile.gender,
                            userName: res.data.profile.userName,
                            email: res.data.profile.email,
                            dob: (res.data.profile.birthday !== undefined && res.data.profile.birthday !== null) ? new Date(res.data.profile.birthday) : '',
                            aslLevel: res.data.profile.aslLevel,
                            startedAge: res.data.profile.startedAge,
                            homeState: res.data.profile.homeState,
                            aboutMe: res.data.profile.about,
                            profileImg: res.data.profile.img,
                            isEditAvailable: (this.state.loggedInUser === this.state.userId),
                            isFlaggedImg: res.data.profile.isFlagged,
                            identity: res.data.profile.identity
                        });
                    }
                }
                else if (res && res.httpServerError) {
                    // throw "Something Went Wrong"
                }
            })
            .catch(err => {
                console.error(err);
                this.setState({ isLoggedOut: false });
            });

    }

    getUserLevelDisplayText = () => {
        if (this.state.userLevelName === "Rookie") {
            return "Rookie";
        }
        return this.state.userLevelName;
    }

    getUserLevelStatus = () => {
        var text = "You are currently at " + this.getUserLevelDisplayText() + " level! ";
        var currentTotalCount = this.state.TotalRecordedVideos;
        if (currentTotalCount < 10) {
            var countReqForNextLevel = 10 - currentTotalCount;
            text += countReqForNextLevel + " videos required to go to pro level!";
        } else if (currentTotalCount <= 49) {
            var countReqForNextLevel1 = 50 - currentTotalCount;
            text += countReqForNextLevel1 + " videos required to go to beast level!";
        }
        this.setState({ userLevelStatusText: text });
    }

    loadUserScores = () => {
        const self = this;

        this.apiClient.getJSON(this, "/getUserScores")
            .then((res) => {
                if (res && res.status) {
                    if (res.data) {
                        var scoresData = res.data;
                        const wikiCount = scoresData.wikiCount;
                        this.setState({
                            userSpecificLevel: scoresData.level,
                            pointScore: scoresData.xpPoints,
                            TotalRecordedVideos: scoresData.totalRecordedVideos,
                            TotalModelVideos: scoresData.totalModelVideos,
                            TotalVerifiedVideos: scoresData.totalVerifiedVideos,
                            TotalUserVideosCount: scoresData.totalUserVideos
                        });
                        this.getUserLevelStatus();
                    }
                }
                else if (res && res.httpServerError) {
                    // throw "Something Went Wrong"
                }
            })
            .catch(err => {
                console.error(err);
                this.setState({ isLoggedOut: false });
            });

    }






    handleInputChange = (event) => {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        this.setState({
            [name]: value
        });
    }


    handleDateChange = (date) => {

        this.setState({ dob: date });
    }

    callSaveProfile = async () => {


        //if (this.state.aboutMe) {

        // let isTextFlagged = await verifyTextContent(this.apiClient, this.state.aboutMe, this, "aboutMarker");
        // if (isTextFlagged) {
        //     return;
        // }

        // }
        // else {
        //     this.setState({ cvsTextProcessing: false });
        // }
        this.setState({ cvsTextProcessing: false });


        var url = "/saveProfile/update";
        const vresponse = await this.apiClient.postJSON(this, url, this.state);
        if (vresponse && vresponse.status) {
            if (vresponse.status === 200) {
                return vresponse;
            }
        }
        else if (vresponse && vresponse.httpServerError) {
            // throw "Something Went Wrong With User Action";
        }
    };

    calculateAge = (bD) => {
        var today = new Date();
        var birthDate = new Date(bD);
        var age = today.getFullYear() - birthDate.getFullYear();
        var m = today.getMonth() - birthDate.getMonth();

        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }
        var ageInYears = age + " yrs";
        this.setState({ userAge: ageInYears });
    }

    saveProfile = async (event) => {
        event.preventDefault();
        let self = this;

        this.calculateAge(new Date(this.state.dob));

        let res = await this.callSaveProfile()

        if (res && res.status === 200) {
            //this.props.history.push('/');
            this.setState({ enableEdit: false });
        } else {
            const error = new Error(res.error);
            throw error;
        }
    }



    _crop() {
        // image in dataUrl
    }

    onImageDrop(files) {
        this.setState({
            uploadedFile: files[0],
            profilepicbuttonsEnable: !(files.length > 0)
        });
        var reader = new FileReader();
        var url = reader.readAsDataURL(files[0]);
        reader.onloadend = function (e) {
            this.setState({
                uploadedImgSrc: reader.result,
                originalImgSrc: reader.result
            })
        }.bind(this);
    };

    toggleUploadPopup = (event) => {
        event.preventDefault();
        this.setState(prevState => ({
            openUploadModal: !prevState.openUploadModal
        }));
    }
    cropImage() {
        if (typeof this.cropper.getCroppedCanvas() === 'undefined') {
            return;
        }
        this.setState({
            uploadedImgSrc: this.cropper.getCroppedCanvas().toDataURL(),
        });
    }
    restoreOriginal() {
        this.setState({
            uploadedImgSrc: this.state.originalImgSrc
        });
    }

    enableEdit(event) {
        event.preventDefault();
        this.setState({ enableEdit: true });
    }

    switchFocus = (tabFocus) => {
        this.setState({ tabState: tabFocus });
    }

    render() {
        if (!this.state.allowProfileRender || !this.state.isYourProfile) {
            return (
                <div>This view has been restricted</div>
            )
        }
        const parsed = queryString.parse(this.props.location.search);
        const userId = parsed.userId !== undefined ? parsed.userId : this.props.loggedInUser;
        const showControl = this.state.enableEdit ? {} : { display: 'none' };
        const hideControl = !this.state.enableEdit ? {} : { display: 'none' };
        const showGender = (this.state.gender === "PNTD" && !this.state.isEditAvailable) ? { display: 'none' } : {};
        const flaggedMsgContent = <p style={this.flggedFontSize}><i><b style={{ color: "#E20C0C" }}>WARNING:</b> This profile pic has been flagged and we are in the process of reviewing it.</i></p>;
        return (
            <React.Fragment>
                <DisappearNotification isTransparent={false} text={this.state.verificationStateText} symbol="processing" showInvisibleModal={this.state.cvsTextProcessing}></DisappearNotification>
                <div className="paddingDivBottom">
                    {/* {(this.state.userName && this.state.isYourProfile) &&
                        <div className="logged-in-widget-cont user-profile">
                            <div className="widget-title">
                                <div className="welcome-user-txt">
                                    Welcome back, {this.state.userName}
                                </div>
                                <div className="welcome-user-subtxt">
                                    {this.state.userSpecificLevel === "MVP" &&
                                        <span>You are currently at {this.state.userSpecificLevel} level!
                                        </span>}
                                    {this.state.userSpecificLevel !== "MVP" &&
                                        <span>You are currently at {this.state.userSpecificLevel} level! Keep adding and verifying videos to get to the next level.
                                        </span>}
                                </div>
                            </div>
                            <div className="widget-body">
                                <div className="rank-col" style={{ borderRight: "1px solid #CCCCCC", paddingRight: "35px" }}>
                                    <div className="widget-row" style={{ marginTop: "-4px" }}>
                                        {this.state.userName}
                                    </div>
                                    <div className="widget-row">
                                        <span className="widget-level-label">
                                            LEVEL
                                        </span>
                                        <span className="widget-level-txt">
                                            {this.state.userSpecificLevel}
                                        </span>
                                    </div>
                                    <div className="widget-row">
                                        <span className="widget-level-label">
                                            Point Score
                                        </span>
                                        <span className="widget-level-txt">
                                            {this.state.xpPoints}
                                        </span>
                                    </div>
                                </div>
                                <div className="rank-col" style={{ marginTop: "-15px" }}>
                                    <div>
                                        <span className="big-verified-count">
                                            {this.state.TotalRecordedVideos}
                                        </span>
                                         <span className="widget-level-txt">
                                            / {this.state.TotalModelVideosCount}
                                        </span> 
                                    </div>
                                    <div>
                                        <span className="widget-level-txt">
                                            Total Recorded Videos
                                        </span>
                                    </div>
                                </div>
                                <div className="rank-col" style={{ marginTop: "-15px" }}>
                                    <div>
                                        <span className="big-verified-count">
                                            {this.state.TotalVerifiedVideos}
                                        </span>
                                        <span className="widget-level-txt">
                                            / {this.state.TotalUserVideosCount}
                                        </span>
                                    </div>
                                    <div>
                                        <span className="widget-level-txt">
                                            Total Verified Videos
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    } */}
                    <div>
                        <div className="tabs-row pr">
                            <div onClick={() => this.switchFocus("Profile")} className="tabs-item" style={{
                                borderBottom: this.state.tabState === "Profile" ? "4px solid #6E6E6E" : "none",
                                color: this.state.tabState === "Profile" ? "#333333" : "#697777",
                                marginLeft: "0px"
                            }}>
                                Profile
                            </div>
                            <div onClick={() => this.switchFocus("DictionaryVideos")} className="tabs-item"
                                style={{
                                    borderBottom: this.state.tabState === "DictionaryVideos" ? "4px solid #6E6E6E" : "none",
                                    color: this.state.tabState === "DictionaryVideos" ? "#333333" : "#697777"
                                }}>
                                Dictionary Videos
                            </div>
                            <div onClick={() => this.switchFocus("WikiVideos")} className="tabs-item"
                                style={{
                                    borderBottom: this.state.tabState === "WikiVideos" ? "4px solid #6E6E6E" : "none",
                                    color: this.state.tabState === "WikiVideos" ? "#333333" : "#697777"
                                }}>
                                Wiki Videos
                            </div>
                        </div>
                    </div>

                    <div style={{ marginBottom: "50px" }}>
                        <div>
                            <div >
                                <div>
                                    {this.state.tabState !== "Profile" &&
                                        <UserVideoListing tabState2={this.state.TotalModelVideos} isYourProfile={this.state.isYourProfile} totalUserVideos={this.state.TotalUserVideosCount}
                                            targetProfileId={this.state.targetProfileId} tabState={this.state.tabState} loggedInUser={this.state.loggedInUser}
                                            userId={this.state.userId} email={this.state.loggedInUserEmail} userLevel={this.state.userLevel} signedInGroupId={this.state.signedInGroupId} />
                                    }
                                    {this.state.tabState === "Profile" &&



                                        <div>
                                            <div style={{ textAlign: "right" }}>
                                                {this.state.enableEdit && <button type="button" className="record-btn" style={showControl} onClick={this.saveProfile} aria-label="Save Profile Info">Save</button>}
                                                {this.state.isEditAvailable &&
                                                    <svg style={hideControl} onClick={this.enableEdit} aria-label="Edit Profile Info" width="112" height="44" viewBox="0 0 112 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M27.6527 28H21.7567V17.4971H27.4183V18.9766H23.4999V21.9502H27.1107V23.4224H23.4999V26.5278H27.6527V28ZM35.9088 28H34.2096V26.7256H34.1803C33.6334 27.6924 32.7911 28.1758 31.6534 28.1758C30.7306 28.1758 29.9908 27.8413 29.4342 27.1724C28.8824 26.4985 28.6065 25.583 28.6065 24.4258C28.6065 23.1855 28.9117 22.1919 29.5221 21.4448C30.1373 20.6978 30.9552 20.3242 31.9757 20.3242C32.9864 20.3242 33.7213 20.7295 34.1803 21.54H34.2096V16.8965H35.9088V28ZM34.2315 24.5723V23.5908C34.2315 23.0586 34.0582 22.6069 33.7115 22.2358C33.3648 21.8647 32.9229 21.6792 32.3858 21.6792C31.7511 21.6792 31.2506 21.916 30.8844 22.3896C30.523 22.8633 30.3424 23.52 30.3424 24.3599C30.3424 25.1216 30.5157 25.7246 30.8624 26.1689C31.214 26.6084 31.6852 26.8281 32.276 26.8281C32.857 26.8281 33.3282 26.6157 33.6896 26.1909C34.0509 25.7612 34.2315 25.2217 34.2315 24.5723ZM38.745 18.9253C38.4666 18.9253 38.2274 18.835 38.0272 18.6543C37.8319 18.4736 37.7342 18.2441 37.7342 17.9658C37.7342 17.6875 37.8319 17.4556 38.0272 17.27C38.2274 17.0845 38.4666 16.9917 38.745 16.9917C39.033 16.9917 39.2772 17.0845 39.4774 17.27C39.6776 17.4556 39.7777 17.6875 39.7777 17.9658C39.7777 18.2295 39.6776 18.4565 39.4774 18.647C39.2772 18.8325 39.033 18.9253 38.745 18.9253ZM39.5872 28H37.888V20.5H39.5872V28ZM45.5289 27.9194C45.1969 28.0854 44.7598 28.1685 44.2179 28.1685C42.7628 28.1685 42.0352 27.4702 42.0352 26.0737V21.833H40.7828V20.5H42.0352V18.7642L43.7345 18.2808V20.5H45.5289V21.833H43.7345V25.583C43.7345 26.0273 43.815 26.3447 43.9762 26.5352C44.1373 26.7256 44.4058 26.8208 44.7818 26.8208C45.0699 26.8208 45.3189 26.7378 45.5289 26.5718V27.9194ZM52.5709 24.1914V28H50.835V17.4971H54.0211C55.2271 17.4971 56.1622 17.7778 56.8262 18.3394C57.4903 18.9009 57.8223 19.6919 57.8223 20.7124C57.8223 21.7329 57.4756 22.5679 56.7823 23.2173C56.0889 23.8667 55.1514 24.1914 53.9698 24.1914H52.5709ZM52.5709 18.9326V22.7705H53.6988C54.4459 22.7705 55.0147 22.5972 55.4053 22.2505C55.796 21.9038 55.9913 21.4155 55.9913 20.7856C55.9913 19.5503 55.2735 18.9326 53.8379 18.9326H52.5709ZM63.5296 22.1187C63.3245 21.9575 63.0291 21.877 62.6434 21.877C62.1404 21.877 61.7205 22.104 61.3836 22.5581C61.0467 23.0122 60.8782 23.6299 60.8782 24.4111V28H59.179V20.5H60.8782V22.0454H60.9075C61.0735 21.5181 61.3274 21.1079 61.6692 20.8149C62.0159 20.5171 62.4017 20.3682 62.8265 20.3682C63.1341 20.3682 63.3685 20.4146 63.5296 20.5073V22.1187ZM67.6841 28.1758C66.5269 28.1758 65.6016 27.8267 64.9082 27.1284C64.2198 26.4253 63.8755 25.4951 63.8755 24.3379C63.8755 23.0781 64.2344 22.0942 64.9522 21.3862C65.6748 20.6782 66.6465 20.3242 67.8672 20.3242C69.0391 20.3242 69.9522 20.6685 70.6065 21.3569C71.2608 22.0454 71.5879 23 71.5879 24.2207C71.5879 25.417 71.2339 26.3765 70.5259 27.0991C69.8228 27.8169 68.8755 28.1758 67.6841 28.1758ZM67.7647 21.6792C67.1006 21.6792 66.5757 21.9111 66.19 22.375C65.8042 22.8389 65.6114 23.4785 65.6114 24.2939C65.6114 25.0801 65.8067 25.7002 66.1973 26.1543C66.5879 26.6035 67.1104 26.8281 67.7647 26.8281C68.4336 26.8281 68.9463 26.606 69.3028 26.1616C69.6641 25.7173 69.8448 25.085 69.8448 24.2646C69.8448 23.4395 69.6641 22.8022 69.3028 22.353C68.9463 21.9038 68.4336 21.6792 67.7647 21.6792ZM77.0755 18.2808C76.846 18.1489 76.5847 18.083 76.2918 18.083C75.4666 18.083 75.054 18.5493 75.054 19.4819V20.5H76.7971V21.833H75.0613V28H73.3621V21.833H72.0804V20.5H73.3621V19.2842C73.3621 18.4932 73.6209 17.8706 74.1385 17.4165C74.656 16.9575 75.303 16.728 76.0794 16.728C76.4993 16.728 76.8313 16.7744 77.0755 16.8672V18.2808ZM78.6226 18.9253C78.3443 18.9253 78.105 18.835 77.9048 18.6543C77.7095 18.4736 77.6118 18.2441 77.6118 17.9658C77.6118 17.6875 77.7095 17.4556 77.9048 17.27C78.105 17.0845 78.3443 16.9917 78.6226 16.9917C78.9107 16.9917 79.1548 17.0845 79.355 17.27C79.5552 17.4556 79.6553 17.6875 79.6553 17.9658C79.6553 18.2295 79.5552 18.4565 79.355 18.647C79.1548 18.8325 78.9107 18.9253 78.6226 18.9253ZM79.4649 28H77.7656V20.5H79.4649V28ZM83.158 28H81.4514V16.8965H83.158V28ZM91.4873 24.7114H86.375C86.3945 25.4048 86.6069 25.9395 87.0122 26.3154C87.4224 26.6914 87.9839 26.8794 88.6968 26.8794C89.4976 26.8794 90.2324 26.6401 90.9014 26.1616V27.5312C90.2178 27.9609 89.3145 28.1758 88.1914 28.1758C87.0879 28.1758 86.2212 27.8364 85.5913 27.1577C84.9663 26.4741 84.6538 25.5146 84.6538 24.2793C84.6538 23.1123 84.998 22.1626 85.6865 21.4302C86.3799 20.6929 87.2393 20.3242 88.2646 20.3242C89.29 20.3242 90.0835 20.6538 90.645 21.313C91.2065 21.9722 91.4873 22.8877 91.4873 24.0596V24.7114ZM89.8467 23.5103C89.8418 22.8999 89.6978 22.4263 89.4146 22.0894C89.1313 21.7476 88.7407 21.5767 88.2427 21.5767C87.7544 21.5767 87.3394 21.7549 86.9976 22.1113C86.6606 22.4678 86.4531 22.9341 86.375 23.5103H89.8467Z" fill="#6E6E6E" />
                                                        <rect x="0.5" y="0.5" width="111" height="43" rx="21.5" stroke="#6E6E6E" />
                                                    </svg>


                                                }
                                            </div>
                                            <div className="profile-row">
                                                <div className="profile-label">
                                                    <p data-tip="This field will be visible to other users.">About</p>
                                                    <ReactTooltip />
                                                </div>
                                                <div className="profile-data">
                                                    {this.state.enableEdit &&
                                                        <React.Fragment>
                                                            <textarea id="aboutTextArea" style={this.profileAboutMe} name="aboutMe" value={this.state.aboutMe}
                                                                onChange={this.handleInputChange} disabled={!this.state.enableEdit}></textarea>
                                                            {this.state.aboutMarker && <span className="margin-top" style={{ color: "red" }} aria-describedby="aboutMe"><i>Please fix the about me content.</i></span>}
                                                        </React.Fragment>
                                                    }
                                                    {!this.state.enableEdit &&
                                                        <p>
                                                            {this.state.aboutMe &&
                                                                <span >{this.state.aboutMe}</span>
                                                            }
                                                            {!this.state.aboutMe &&
                                                                <span className="not-available">None Selected</span>
                                                            }
                                                        </p>
                                                    }
                                                </div>
                                            </div>
                                            {this.state.isYourProfile && <div className="profile-row">
                                                <div className="profile-label">
                                                    <p data-tip="This field will be visible to other users.">Username</p>
                                                </div>
                                                <div className="profile-data">
                                                    {this.state.enableEdit &&
                                                        <input style={this.inputFieldDisplay}
                                                            id="userNameInput"
                                                            type="text"
                                                            name="userName"
                                                            disabled={true}
                                                            //placeholder="Enter name"
                                                            value={this.state.userName}
                                                        />
                                                    }
                                                    {!this.state.enableEdit &&
                                                        <p>
                                                            {this.state.email !== undefined &&
                                                                <span >{this.state.userName}</span>
                                                            }
                                                            {this.state.userName === undefined &&
                                                                <span className="not-available">None Selected</span>
                                                            }
                                                        </p>
                                                    }
                                                </div>
                                            </div>
                                            }
                                            {this.state.isYourProfile && <div className="profile-row">
                                                <div className="profile-label">
                                                    <ReactTooltip />
                                                    <p data-tip="This field will NOT be visible to other users.">Email</p>
                                                </div>
                                                <div className="profile-data">
                                                    {this.state.enableEdit &&
                                                        <input style={this.inputFieldDisplay}
                                                            id="emailInput"
                                                            type="text"
                                                            name="email"
                                                            disabled={true}
                                                            //placeholder="Enter name"
                                                            value={this.state.email}
                                                        />

                                                    }
                                                    {!this.state.enableEdit &&
                                                        <p>
                                                            {this.state.email !== undefined &&
                                                                <span >{this.state.email}</span>
                                                            }
                                                            {this.state.email === undefined &&
                                                                <span className="not-available">None Selected</span>
                                                            }
                                                        </p>
                                                    }
                                                </div>
                                            </div>
                                            }
                                            <div style={showGender}>
                                                <div className="profile-row">
                                                    <div className="profile-label">
                                                        <ReactTooltip />
                                                        <p data-tip="This field will be visible to other users.">Gender</p>
                                                    </div>
                                                    <div className="profile-data">
                                                        {this.state.enableEdit && <select id="genderProfile" style={this.selectFieldDisplay} disabled={!this.state.enableEdit} name="gender" value={this.state.gender} onChange={this.handleInputChange} >
                                                            <option value="">Please Select</option>
                                                            <option value="Male">Male</option>
                                                            <option value="Female">Female</option>
                                                            <option value="Other">Other</option>
                                                            <option value="PNTD">Prefer not to disclose</option>
                                                        </select>
                                                        }
                                                        {!this.state.enableEdit &&
                                                            <div>
                                                                {this.state.gender &&
                                                                    <span >{this.state.gender}</span>
                                                                }
                                                                {!this.state.gender &&
                                                                    <span className="not-available">None Selected</span>
                                                                }
                                                            </div>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                            <div style={hideControl}>
                                                <div className="profile-row">
                                                    <div className="profile-label">
                                                        <ReactTooltip />
                                                        <p data-tip="This field will NOT be visible to other users, but your age in years will be visible to other users.">Age</p>

                                                    </div>
                                                    <div className="profile-data">
                                                        {this.state.enableEdit &&
                                                            <input id="ageProfile" style={this.inputFieldDisplay}
                                                                type="text"
                                                                name="userAge"
                                                                disabled={!this.state.enableEdit}
                                                                value={this.state.userAge}
                                                            />
                                                        }
                                                        {!this.state.enableEdit &&
                                                            <p>
                                                                {this.state.userAge &&
                                                                    <span >{this.state.userAge}</span>
                                                                }
                                                                {!this.state.userAge &&
                                                                    <span className="not-available">None Selected</span>
                                                                }
                                                            </p>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                            <div style={showControl}>
                                                <div className="profile-row">
                                                    <div className="profile-label">
                                                        <ReactTooltip />
                                                        <p data-tip="This field will NOT be visible to other users, but your age in years will be visible to other users.">Birthday</p>
                                                    </div>
                                                    <div className="profile-data" style={{ marginLeft: "-16px" }}>
                                                        <DatePicker
                                                            id="birthdayProfile"
                                                            name="dob"
                                                            disabled={!this.state.enableEdit}
                                                            selected={this.state.dob}
                                                            placeholderText="MM/DD/YYYY"
                                                            onSelect={date => this.handleDateChange(date)}
                                                            required />
                                                    </div>
                                                </div>
                                            </div>
                                            {this.state.isYourProfile &&
                                                <div className="profile-row">
                                                    <div className="profile-label">
                                                        <ReactTooltip />
                                                        <p data-tip="This field will NOT be visible to other users, but may help advance research.">Identify</p>
                                                    </div>
                                                    {this.state.enableEdit && <div className="profile-data">
                                                        <select id="identifyLevelProfile" name="identity" style={this.selectFieldDisplay} disabled={!this.state.enableEdit} value={this.state.identity} onChange={this.handleInputChange} >
                                                            <option value="">Please Select</option>
                                                            <option value="DEAF">Deaf</option>
                                                            <option value="HOH">Hard-of-Hearing</option>
                                                            <option value="HEAR">Hearing</option>
                                                            <option value="Other">Other</option>
                                                        </select>

                                                    </div>
                                                    }
                                                    {!this.state.enableEdit &&
                                                        <p>
                                                            {this.state.identity &&
                                                                <span >{this.state.identity}</span>
                                                            }
                                                            {!this.state.identity === undefined &&
                                                                <span className="not-available">None Selected</span>
                                                            }
                                                        </p>
                                                    }

                                                </div>
                                            }

                                            <div className="profile-row">
                                                <div className="profile-label">
                                                    <ReactTooltip />
                                                    <p data-tip="This field will be visible to other users.">ASL Level</p>
                                                </div>
                                                <div className="profile-data">


                                                    {this.state.enableEdit &&
                                                        <select id="aslLevelProfile" name="aslLevel" style={this.selectFieldDisplay}
                                                            disabled={!this.state.enableEdit} value={this.state.aslLevel} onChange={this.handleInputChange} >
                                                            <option value="">Please Select</option>
                                                            <option value="1">1 - I do not use ASL</option>
                                                            <option value="2">2</option>
                                                            <option value="3">3</option>
                                                            <option value="4">4</option>
                                                            <option value="5">5</option>
                                                            <option value="6">6</option>
                                                            <option value="7">7 - Fluent</option>
                                                        </select>
                                                    }
                                                    {!this.state.enableEdit &&
                                                        <p>
                                                            {this.state.aslLevel &&
                                                                <span >{this.state.aslLevel}</span>
                                                            }
                                                            {!this.state.aslLevel &&
                                                                <span className="not-available">None Selected</span>
                                                            }
                                                        </p>
                                                    }

                                                </div>

                                            </div>
                                            <div>
                                                {this.state.isYourProfile &&
                                                    <div className="profile-row">
                                                        <div className="profile-label">
                                                            <ReactTooltip />
                                                            <p data-tip="This field will NOT be visible to other users, but may help advance research.">Age learning ASL</p>
                                                        </div>
                                                        <div className="profile-data">
                                                            {this.state.enableEdit &&
                                                                <input style={this.inputFieldDisplay}
                                                                    id="ageASLInput"
                                                                    type="text"
                                                                    name="startedAge"
                                                                    //placeholder="Enter name"
                                                                    value={this.state.startedAge}
                                                                    onChange={this.handleInputChange}
                                                                />
                                                            }
                                                            {!this.state.enableEdit &&
                                                                <p>
                                                                    {this.state.startedAge !== undefined &&
                                                                        <span >{this.state.startedAge}</span>
                                                                    }
                                                                    {this.state.startedAge === undefined &&
                                                                        <span className="not-available">None Selected</span>
                                                                    }
                                                                </p>
                                                            }
                                                        </div>
                                                    </div>
                                                }
                                            </div>

                                            <div className="profile-row">
                                                <div className="profile-label">
                                                    <ReactTooltip />
                                                    <p data-tip="This field will be visible to other users.">Home State</p>
                                                </div>
                                                <div className="profile-data">



                                                    {this.state.enableEdit &&
                                                        <select id="homeStateProfile" name="homeState" disabled={!this.state.enableEdit} style={this.selectFieldDisplay} value={this.state.homeState} onChange={this.handleInputChange} >
                                                            <option value="">Please Select</option>
                                                            <option value="AL">Albama</option>
                                                            <option value="AL">Alaska</option>
                                                            <option value="AZ">Arizona</option>
                                                            <option value="AR">Arkansas</option>
                                                            <option value="CA">California</option>
                                                            <option value="CO">Colorado</option>
                                                            <option value="CT">Connecticut</option>
                                                            <option value="DE">Delaware</option>
                                                            <option value="FL">Florida</option>
                                                            <option value="GA">Georgia</option>
                                                            <option value="HI">Hawaii</option>
                                                            <option value="ID">Idaho</option>
                                                            <option value="IL">Illinois</option>
                                                            <option value="IN">Indiana</option>
                                                            <option value="IA">Iowa</option>
                                                            <option value="KS">Kansas</option>
                                                            <option value="KY">Kentucky</option>
                                                            <option value="LA">Louisiana</option>
                                                            <option value="ME">Maine</option>
                                                            <option value="MD">Maryland</option>
                                                            <option value="MA">Massachusetts</option>
                                                            <option value="MI">Michigan</option>
                                                            <option value="MN">Minnesota</option>
                                                            <option value="MS">Mississippi</option>
                                                            <option value="MO">Missouri</option>
                                                            <option value="MT">Montana</option>
                                                            <option value="NE">Nebraska</option>
                                                            <option value="NV">Nevada</option>
                                                            <option value="NH">New Hampshire</option>
                                                            <option value="NJ">New Jersey</option>
                                                            <option value="NM">New Mexico</option>
                                                            <option value="NY">New York</option>
                                                            <option value="NC">North Carolina</option>
                                                            <option value="ND">North Dakota</option>
                                                            <option value="OH">Ohio</option>
                                                            <option value="OK">Oklahoma</option>
                                                            <option value="OR">Oregon</option>
                                                            <option value="PA">Pennsylvania</option>
                                                            <option value="RI">Rhode Island</option>
                                                            <option value="SC">South Carolina</option>
                                                            <option value="SD">South Dakota</option>
                                                            <option value="TN">Tennessee</option>
                                                            <option value="TX">Texas</option>
                                                            <option value="UT">Utah</option>
                                                            <option value="VT">Vermont</option>
                                                            <option value="VA">Virginia</option>
                                                            <option value="WA">Washington</option>
                                                            <option value="WV">West Virginia</option>
                                                            <option value="WI">Wisconsin</option>
                                                            <option value="WY">Wyoming</option>
                                                        </select>
                                                    }
                                                    {!this.state.enableEdit &&
                                                        <p>
                                                            {this.state.homeState &&
                                                                <span >{this.state.homeState}</span>
                                                            }
                                                            {!this.state.homeState &&
                                                                <span className="not-available">None Selected</span>
                                                            }
                                                        </p>
                                                    }

                                                </div>
                                            </div>
                                            <div>
                                                {this.state.isYourProfile && <div className="nav-anchorLink" style={{ marginTop: "50px", cursor: "pointer" }} onClick={this.showConfirmDeleteDialog} aria-label="DeleteUserAccountlink">
                                                    Delete Account
                                                </div>
                                                }
                                                {(this.state.isYourProfile && this.state.showConfirmDeleteDialog) && <AriaModal
                                                    titleText="Delete Account"
                                                    onExit={this.handleClose}
                                                    verticallyCenter={true}
                                                    initialFocus="#yes-button"
                                                    getApplicationNode={this.getApplicationNode}
                                                    underlayStyle={{ paddingTop: '2em' }}>
                                                    <div className="aria-modal" style={{ cursor: "pointer" }}>
                                                        <header>
                                                            <h3 style={this.textDecoration}>
                                                                Delete Account
                                                            </h3>
                                                        </header>
                                                        <div id="message-content">
                                                            <p tabIndex="0" id="message">Are you sure you want to delete your account? All of your videos and other data will be deleted, and will not be recoverable. Click yes to continue.</p>
                                                        </div>
                                                        <div style={{ textAlign: "center" }}>
                                                            <div style={{ display: "inline-block" }}>
                                                                <button id="yes-button" style={{ marginRight: "10px" }} onClick={this.deleteUserAccount} aria-label="Click button to continue deleting the user account">Yes</button>
                                                                <button onClick={this.showConfirmDeleteDialog} aria-label="Click button to Cancel user account deletion">No</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </AriaModal>}
                                            </div>
                                        </div>




                                    }
                                </div>
                            </div>
                        </div>


                    </div>

                </div>
                <Modal width="500" isOpen={this.state.openUploadModal} toggle={this.toggleUploadPopup} className="modal-lg">
                    <ModalHeader toggle={this.toggleUploadPopup}>UPLOAD IMAGE</ModalHeader>
                    <ModalBody>
                        <Dropzone
                            onDrop={this.onImageDrop.bind(this)}
                            accept="image/*"
                            multiple={false}>
                            {({ getRootProps, getInputProps }) => {
                                return (
                                    <div
                                        {...getRootProps()}
                                    >
                                        <input {...getInputProps()} />
                                        {
                                            <p style={this.linkChangeProfilePic}>Click here to select the files to upload</p>
                                        }
                                    </div>
                                )
                            }}
                        </Dropzone>
                        {/* <div className="scroll-content">
                            <input type="file" id="photo" onChange={this.onImageDrop} />
                        </div> */}
                        <Cropper
                            ref={cropper => { this.cropper = cropper; }}
                            src={this.state.uploadedImgSrc}
                            style={{ height: 400, width: '100%', margin: '10' }}
                            // Cropper.js options
                            aspectRatio={1 / 1}
                            guides={false}
                            crop={this._crop.bind(this)} />
                        <button onClick={this.cropImage} style={{ float: 'right' }} disabled={this.state.profilepicbuttonsEnable}>
                            Crop Image
                        </button>
                        <button onClick={this.restoreOriginal} style={{ float: 'right' }} disabled={this.state.profilepicbuttonsEnable}>
                            Original
                        </button>
                        {/* <button onClick={this.updateProfileImage} style={{ float: 'right' }}>
                Upload
              </button> */}
                    </ModalBody>
                    <ModalFooter>
                        <Button color="primary" onClick={this.updateProfileImage}>Save Image</Button>{' '}
                        <Button color="secondary" onClick={this.toggleUploadPopup}>Cancel</Button>
                    </ModalFooter>
                </Modal>
            </React.Fragment>
        )
    }
}

const mapDispatchToProps = (dispatch) => ({
    updateScore,
    populateStore,
    requestFailedModal,
    dispatch
});

const UserProfile = connect(
    
    mapDispatchToProps
)(UserProfileContainer);


export default UserProfile
